<template>
    <div class="xinwenke-page">
      <div v-loading="loading">
        <main>
          <!-- 轮播 -->
          <div class="swiper">
            <div class="swiperBox" id="swiper">
              <el-carousel :height="swiperHeight">
                <el-carousel-item v-for="(item, index) in ppttrack" :key="index">
                  <template v-if="item.type == 2">
                    <a :href="item.url" target="_blank">
                      <img
                        class="bannImage"
                        :src="item.image"
                        alt=""
                        @click="addUrl(item)"
                      />
                    </a>
                  </template>
                  <template v-else>
                    <img
                      class="bannImage"
                      :src="item.image"
                      alt=""
                      @click="addUrl(item)"
                    />
                  </template>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
  
          <!-- 新文科模块标题 -->
          <div class="xinwenke-title-section">
            <div class="xinwenke-title-header">
              <h2>新文科实践创新大赛</h2>
              <p>融/创/赋/能　&nbsp;实/践/创/新</p>
            </div>
          </div>
  
          <!-- 新文科四大模块 -->
          <div class="xinwenke-modules">
            <!-- 政史哲模块 -->
            <div class="module-section">
              <div class="module-header">
                <h2>文学、历史学、哲学类项目</h2>
                <p>POLITICS HISTORY PHILOSOPHY</p>
              </div>
              <div class="category-tabs">
                <div
                  v-for="category in zhengshizheCategories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: zhengshizheSelectedCategory === category.id }
                  ]"
                  @click="selectModuleCategory('zhengshizhe', category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
              <div class="subcategory-tabs" v-if="zhengshizheCategories.length > 0">
                <div
                  v-for="subcategory in getZhengshizheSubcategories()"
                  :key="subcategory.id"
                  :class="[
                    'subcategory-tab',
                    { active: zhengshizheSelectedSubcategory === subcategory.id }
                  ]"
                  @click="selectModuleSubcategory('zhengshizhe', subcategory.id)"
                >
                  {{ subcategory.name }}
                </div>
              </div>
              <div class="files-grid" v-if="zhengshizheFiles.length > 0">
                <div
                  v-for="file in zhengshizheFiles"
                  :key="file.id"
                  class="file-card"
                  @click="viewFile(file)"
                >
                  <div class="file-image">
                    <img :src="file.cover || file.image" :alt="file.name" />
                  </div>
                  <div class="file-info">
                    <div class="file-header">
                      <div class="file-type">{{ getSubcategoryName(file.subcategoryId) }}</div>
                    </div>
                    <div class="file-content">
                      <div class="file-left">
                        <h3>{{ file.name }}</h3>
                      </div>
                      <div class="file-right">
                        <div class="file-stats">
                          <span class="stat-item">
                            <i class="el-icon-star-on"></i>
                            {{ file.laud || 0 }}
                          </span>
                          <span class="stat-item">
                            <i class="el-icon-view"></i>
                            {{ file.pv || 0 }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="pagination-container" v-if="zhengshizheFiles.length > 0">
                <el-pagination
                  @current-change="handleZhengshizhePageChange"
                  :current-page="zhengshizhePageNum"
                  :page-size="pageSize"
                  :total="zhengshizheTotal"
                  layout="prev, pager, next"
                  :pager-count="5"
                  :hide-on-single-page="false"
                  prev-text="上一页"
                  next-text="下一页"
                >
                </el-pagination>
              </div>
            </div>
  
            <!-- 经管法模块 -->
            <div class="module-section">
              <div class="module-header">
                <h2>经济学、管理学、法学类项目</h2>
                <p>ECONOMICS MANAGEMENT LAW</p>
              </div>
              <div class="category-tabs">
                <div
                  v-for="category in jingguanfaCategories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: jingguanfaSelectedCategory === category.id }
                  ]"
                  @click="selectModuleCategory('jingguanfa', category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
              <div class="subcategory-tabs" v-if="jingguanfaCategories.length > 0">
                <div
                  v-for="subcategory in getJingguanfaSubcategories()"
                  :key="subcategory.id"
                  :class="[
                    'subcategory-tab',
                    { active: jingguanfaSelectedSubcategory === subcategory.id }
                  ]"
                  @click="selectModuleSubcategory('jingguanfa', subcategory.id)"
                >
                  {{ subcategory.name }}
                </div>
              </div>
              <div class="files-grid" v-if="jingguanfaFiles.length > 0">
                <div
                  v-for="file in jingguanfaFiles"
                  :key="file.id"
                  class="file-card"
                  @click="viewFile(file)"
                >
                  <div class="file-image">
                    <img :src="file.cover || file.image" :alt="file.name" />
                  </div>
                  <div class="file-info">
                    <div class="file-header">
                      <div class="file-type">{{ getSubcategoryName(file.subcategoryId) }}</div>
                    </div>
                    <div class="file-content">
                      <div class="file-left">
                        <h3>{{ file.name }}</h3>
                      </div>
                      <div class="file-right">
                        <div class="file-stats">
                          <span class="stat-item">
                            <i class="el-icon-star-on"></i>
                            {{ file.laud || 0 }}
                          </span>
                          <span class="stat-item">
                            <i class="el-icon-view"></i>
                            {{ file.pv || 0 }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="pagination-container" v-if="jingguanfaFiles.length > 0">
                <el-pagination
                  @current-change="handleJingguanfaPageChange"
                  :current-page="jingguanfaPageNum"
                  :page-size="pageSize"
                  :total="jingguanfaTotal"
                  layout="prev, pager, next"
                  :pager-count="5"
                  :hide-on-single-page="false"
                  prev-text="上一页"
                  next-text="下一页"
                >
                </el-pagination>
              </div>
            </div>
  
            <!-- 教育模块 -->
            <div class="module-section">
              <div class="module-header">
                <h2>教育学类项目</h2>
                <p>EDUCATION</p>
              </div>
              <div class="category-tabs">
                <div
                  v-for="category in jiaoyuCategories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: jiaoyuSelectedCategory === category.id }
                  ]"
                  @click="selectModuleCategory('jiaoyu', category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
              <div class="subcategory-tabs" v-if="jiaoyuCategories.length > 0">
                <div
                  v-for="subcategory in getJiaoyuSubcategories()"
                  :key="subcategory.id"
                  :class="[
                    'subcategory-tab',
                    { active: jiaoyuSelectedSubcategory === subcategory.id }
                  ]"
                  @click="selectModuleSubcategory('jiaoyu', subcategory.id)"
                >
                  {{ subcategory.name }}
                </div>
              </div>
              <div class="files-grid" v-if="jiaoyuFiles.length > 0">
                <div
                  v-for="file in jiaoyuFiles"
                  :key="file.id"
                  class="file-card"
                  @click="viewFile(file)"
                >
                  <div class="file-image">
                    <img :src="file.cover || file.image" :alt="file.name" />
                  </div>
                  <div class="file-info">
                    <div class="file-header">
                      <div class="file-type">{{ getSubcategoryName(file.subcategoryId) }}</div>
                    </div>
                    <div class="file-content">
                      <div class="file-left">
                        <h3>{{ file.name }}</h3>
                      </div>
                      <div class="file-right">
                        <div class="file-stats">
                          <span class="stat-item">
                            <i class="el-icon-star-on"></i>
                            {{ file.laud || 0 }}
                          </span>
                          <span class="stat-item">
                            <i class="el-icon-view"></i>
                            {{ file.pv || 0 }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="pagination-container" v-if="jiaoyuFiles.length > 0">
                <el-pagination
                  @current-change="handleJiaoyuPageChange"
                  :current-page="jiaoyuPageNum"
                  :page-size="pageSize"
                  :total="jiaoyuTotal"
                  layout="prev, pager, next"
                  :pager-count="5"
                  :hide-on-single-page="false"
                  prev-text="上一页"
                  next-text="下一页"
                >
                </el-pagination>
              </div>
            </div>
  
            <!-- 艺术模块 -->
            <div class="module-section">
              <div class="module-header">
                <h2>艺术学类项目</h2>
                <p>ARTS</p>
              </div>
              <div class="category-tabs">
                <div
                  v-for="category in yishuCategories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: yishuSelectedCategory === category.id }
                  ]"
                  @click="selectModuleCategory('yishu', category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
              <div class="subcategory-tabs" v-if="yishuCategories.length > 0">
                <div
                  v-for="subcategory in getYishuSubcategories()"
                  :key="subcategory.id"
                  :class="[
                    'subcategory-tab',
                    { active: yishuSelectedSubcategory === subcategory.id }
                  ]"
                  @click="selectModuleSubcategory('yishu', subcategory.id)"
                >
                  {{ subcategory.name }}
                </div>
              </div>
              <div class="files-grid" v-if="yishuFiles.length > 0">
                <div
                  v-for="file in yishuFiles"
                  :key="file.id"
                  class="file-card"
                  @click="viewFile(file)"
                >
                  <div class="file-image">
                    <img :src="file.cover || file.image" :alt="file.name" />
                  </div>
                  <div class="file-info">
                    <div class="file-header">
                      <div class="file-type">{{ getSubcategoryName(file.subcategoryId) }}</div>
                    </div>
                    <div class="file-content">
                      <div class="file-left">
                        <h3>{{ file.name }}</h3>
                      </div>
                      <div class="file-right">
                        <div class="file-stats">
                          <span class="stat-item">
                            <i class="el-icon-star-on"></i>
                            {{ file.laud || 0 }}
                          </span>
                          <span class="stat-item">
                            <i class="el-icon-view"></i>
                            {{ file.pv || 0 }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="pagination-container" v-if="yishuFiles.length > 0">
                <el-pagination
                  @current-change="handleYishuPageChange"
                  :current-page="yishuPageNum"
                  :page-size="pageSize"
                  :total="yishuTotal"
                  layout="prev, pager, next"
                  :pager-count="5"
                  :hide-on-single-page="false"
                  prev-text="上一页"
                  next-text="下一页"
                >
                </el-pagination>
              </div>
            </div>
          </div>
  
          <!-- 用户评价轮播区域 -->
          <div class="reviews-section">
            <div class="reviews-container">
              <div class="reviews-header">
                <h2>用户真实评价</h2>
                <p>USER REVIEWS</p>
              </div>
              <div class="reviews-content">
                <vue-seamless-scroll
                  :data="reviewData1"
                  :class-option="reviewOption1"
                  ref="reviewScroll1"
                  class="review-scroll"
                >
                  <ul>
                    <li
                      class="review-item"
                      v-for="(item, index) in reviewData1"
                      :key="'r1' + index"
                    >
                      <div class="review-avatar">
                        <img :src="item.avatar" alt="" />
                      </div>
                      <div class="review-content">
                        <div class="review-text">{{ item.content }}</div>
                        <div class="review-user">{{ item.username }}</div>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
                <vue-seamless-scroll
                  :data="reviewData2"
                  :class-option="reviewOption2"
                  ref="reviewScroll2"
                  class="review-scroll"
                >
                  <ul>
                    <li
                      class="review-item"
                      v-for="(item, index) in reviewData2"
                      :key="'r2' + index"
                    >
                      <div class="review-avatar">
                        <img :src="item.avatar" alt="" />
                      </div>
                      <div class="review-content">
                        <div class="review-text">{{ item.content }}</div>
                        <div class="review-user">{{ item.username }}</div>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
  
          <!-- 服务保障区域 -->
          <div class="itmentBox">
            <ul class="tment_ul clearfix">
              <li>
                <i class="iconfont iconbanquan"></i>
                <p class="decla_title">正版承诺</p>
                <p class="decla_intro">拒绝盗版，获设计师独家授权</p>
              </li>
              <li>
                <i class="iconfont iconbanquan1"></i>
                <p class="decla_title">版权保障 商用无忧</p>
                <p class="decla_intro">对全站所有模板均拥有商用授权</p>
              </li>
              <li class="last_item">
                <i class="iconfont icontiexinfuwu"></i>
                <p class="decla_title">全天候 贴心服务</p>
                <p class="decla_intro">
                  发票支持，报销无忧<br />团队协作，院校会员可多人使用
                </p>
              </li>
            </ul>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations } from "vuex";
  
  export default {
    name: "XinWenKePage",
    data() {
      return {
        ppttrack: [],
        screenWidth: document.body.clientWidth,
        swiperHeight: "625px",
        loading: false,
  
        // 用户评价数据
        reviewData1: [],
        reviewData2: [],
  
        // 分类数据
        categories: [],
        subcategories: [],
  
        // 选中的模块和分类
        selectedModule: 'zhengshizhe', // 默认选中政史哲模块
        selectedCategory: null,
        selectedSubcategory: null,
  
        // 当前文件列表
        currentFiles: [],
  
        // 分页
        pageNum: 1,
        pageSize: 8, // 改为8个文件
        total: 0,
  
        // 各模块的文件数据
        zhengshizheFiles: [],
        jingguanfaFiles: [],
        jiaoyuFiles: [],
        yishuFiles: [],
  
        // 各模块的分页数据
        zhengshizhePageNum: 1,
        jingguanfaPageNum: 1,
        jiaoyuPageNum: 1,
        yishuPageNum: 1,
  
        zhengshizheTotal: 0,
        jingguanfaTotal: 0,
        jiaoyuTotal: 0,
        yishuTotal: 0,
  
        // 各模块的选中状态
        zhengshizheSelectedCategory: null,
        jingguanfaSelectedCategory: null,
        jiaoyuSelectedCategory: null,
        yishuSelectedCategory: null,
  
        zhengshizheSelectedSubcategory: null,
        jingguanfaSelectedSubcategory: null,
        jiaoyuSelectedSubcategory: null,
        yishuSelectedSubcategory: null,
  
        // 四大模块分类
        zhengshizheCategories: [], // 政史哲：政治、历史、哲学
        jingguanfaCategories: [], // 经管法：经济、管理、法律
        jiaoyuCategories: [], // 教育：教育
        yishuCategories: [] // 艺术：艺术
      };
    },
    computed: {
      ...mapState(["nav"]),
      reviewOption1() {
        return {
          step: 0.8,
          limitMoveNum: 0,
          hoverStop: true,
          direction: 2,
          openWatch: true,
          singleHeight: 0,
          singleWidth: 0,
          waitTime: 1500
        };
      },
      reviewOption2() {
        return {
          step: 0.8,
          limitMoveNum: 0,
          hoverStop: true,
          direction: 3,
          openWatch: true,
          singleHeight: 0,
          singleWidth: 0,
          waitTime: 1500
        };
      }
    },
    methods: {
      // 加载初始数据
      loadInitialData() {
        // 使用新的首页数据接口一次性获取所有数据
        this.loadIndexData().then(() => {
          // 数据加载完成后，统一设置选中状态
          this.setAllDefaultSelections();
        }).catch(err => {
          this.$message.error('数据加载失败，请刷新页面重试');
        });
      },
  
      // 加载首页数据（新接口 - 包含分类菜单和四大模块数据）
      loadIndexData() {
        return new Promise((resolve, reject) => {
          const params = {
            sort: "new",
            pageSize: this.pageSize
          };
          
          this.axios
            .getXinWenKeIndex(params)
            .then(res => {
              if (res.data.code === 200) {
                const data = res.data.data || {};
                
                // 提取分类数据
                this.categories = data.categories || [];
                this.subcategories = data.subcategories || [];
                
                // 组织分类到四大模块
                this.organizeCategories();
                
                // 处理四大模块数据
                this.processModulesData(data.modules || {});
                
                resolve(res.data);
              } else {
                reject(new Error('首页数据加载失败'));
              }
            })
            .catch(err => {
              reject(err);
            });
        });
      },
  
      // 处理四大模块数据
      processModulesData(modules) {
        // 处理政史哲模块数据
        if (modules.module1) {
          this.zhengshizheFiles = modules.module1.files || [];
          this.zhengshizheTotal = modules.module1.total || 0;
          this.zhengshizheSelectedCategory = modules.module1.categoryId;
          this.zhengshizheSelectedSubcategory = modules.module1.subcategoryId;
        }
        
        // 处理经管法模块数据
        if (modules.module2) {
          this.jingguanfaFiles = modules.module2.files || [];
          this.jingguanfaTotal = modules.module2.total || 0;
          this.jingguanfaSelectedCategory = modules.module2.categoryId;
          this.jingguanfaSelectedSubcategory = modules.module2.subcategoryId;
        }
        
        // 处理教育模块数据
        if (modules.module3) {
          this.jiaoyuFiles = modules.module3.files || [];
          this.jiaoyuTotal = modules.module3.total || 0;
          this.jiaoyuSelectedCategory = modules.module3.categoryId;
          this.jiaoyuSelectedSubcategory = modules.module3.subcategoryId;
        }
        
        // 处理艺术模块数据
        if (modules.module4) {
          this.yishuFiles = modules.module4.files || [];
          this.yishuTotal = modules.module4.total || 0;
          this.yishuSelectedCategory = modules.module4.categoryId;
          this.yishuSelectedSubcategory = modules.module4.subcategoryId;
        }
      },
  
      // 加载分类数据（保留兼容性）
      loadCategoriesData() {
        return new Promise((resolve, reject) => {
          this.axios
            .getXinWenKeCategories()
            .then(res => {
              if (res.data.code === 200) {
                // 根据后端接口文档，分类菜单返回的是包含subcategories的完整结构
                this.categories = res.data.data || [];
                this.organizeCategories();
                resolve(res.data);
              } else {
                reject(new Error('分类数据加载失败'));
              }
            })
            .catch(err => {
              reject(err);
            });
        });
      },
  
      // 加载子分类数据
      loadSubcategoriesData() {
        return new Promise((resolve, reject) => {
          this.axios
            .getXinWenKeSubcategories()
            .then(res => {
              if (res.data.code === 200) {
                this.subcategories = res.data.data;
                resolve(res.data);
              } else {
                reject(new Error('子分类数据加载失败'));
              }
            })
            .catch(err => {
              reject(err);
            });
        });
      },
  
      // 设置所有默认选中状态
      setAllDefaultSelections() {
        // 为所有模块设置默认选中状态（只有在没有预设状态时才设置）
        this.setModuleDefaultSelections('zhengshizhe', this.zhengshizheCategories);
        this.setModuleDefaultSelections('jingguanfa', this.jingguanfaCategories);
        this.setModuleDefaultSelections('jiaoyu', this.jiaoyuCategories);
        this.setModuleDefaultSelections('yishu', this.yishuCategories);
        
        // 设置全局默认选中状态（政史哲模块）
        if (this.zhengshizheCategories.length > 0) {
          this.selectedModule = 'zhengshizhe';
          this.selectedCategory = this.zhengshizheSelectedCategory || this.zhengshizheCategories[0].id;
          
          // 如果没有预设的子分类，则选择第一个子分类
          if (!this.zhengshizheSelectedSubcategory) {
            const moduleSubcategories = this.subcategories.filter(sub => sub.categoryId === this.selectedCategory);
            if (moduleSubcategories.length > 0) {
              this.zhengshizheSelectedSubcategory = moduleSubcategories[0].id;
              this.selectedSubcategory = this.zhengshizheSelectedSubcategory;
            }
          } else {
            this.selectedSubcategory = this.zhengshizheSelectedSubcategory;
          }
        }
      },

      // 为指定模块设置默认选中状态（只有在没有预设状态时才设置）
      setModuleDefaultSelections(moduleName, categories) {
        if (categories.length > 0) {
          const selectedCategoryKey = `${moduleName}SelectedCategory`;
          const selectedSubcategoryKey = `${moduleName}SelectedSubcategory`;
          
          // 如果没有预设的分类，则选择第一个分类
          if (!this[selectedCategoryKey]) {
            this[selectedCategoryKey] = categories[0].id;
          }
          
          // 如果没有预设的子分类，则选择第一个子分类
          if (!this[selectedSubcategoryKey]) {
            const moduleSubcategories = this.subcategories.filter(sub => sub.categoryId === this[selectedCategoryKey]);
            if (moduleSubcategories.length > 0) {
              this[selectedSubcategoryKey] = moduleSubcategories[0].id;
            }
          }
        }
      },
  
  
      // 获取轮播图
      getSwiperData() {
        this.axios
          .getXinWenKeBanners({})
          .then(res => {
            if (res.data.code == 200) {
              this.ppttrack = res.data.data;
            } else {
              this.ppttrack = [];
            }
          })
          .catch(err => {
            this.$message.error("轮播图加载失败");
          });
      },
  
      // 获取用户评价数据
      getReviewData() {
        this.axios
          .indexMsg({})
          .then(res => {
            if (res.data.code == 200) {
              this.reviewData1 = res.data.data.s1 || [];
              this.reviewData2 = res.data.data.s2 || [];
              this.$nextTick(() => {
                this.$refs.reviewScroll1 && this.$refs.reviewScroll1.reset();
                this.$refs.reviewScroll2 && this.$refs.reviewScroll2.reset();
              });
            }
          })
          .catch(err => {
            // 评价数据加载失败，静默处理
          });
      },
  
  
      // 组织分类到四大模块
      organizeCategories() {
        // 根据实际后端返回的分类名称进行匹配
        // 第一个模块：政史哲模块 - 包含文学、历史、哲学
        this.zhengshizheCategories = this.categories.filter(cat =>
          ["文学", "历史", "哲学", "政治"].includes(cat.name)
        );
        // 第二个模块：经管法模块 - 包含经济、管理、法律
        this.jingguanfaCategories = this.categories.filter(cat =>
          ["经济", "管理", "法律"].includes(cat.name)
        );
        // 第三个模块：教育模块 - 包含教育
        this.jiaoyuCategories = this.categories.filter(cat =>
          ["教育"].includes(cat.name)
        );
        // 第四个模块：艺术模块 - 包含艺术
        this.yishuCategories = this.categories.filter(cat =>
          ["艺术"].includes(cat.name)
        );
      },
  
      // 为指定模块按需加载文件数据（使用指定的子分类）
      loadModuleFilesWithSpecificSubcategory(module, categoryId, subcategoryId, pageNum = 1) {
        const params = {
          categoryId: categoryId,
          subcategoryId: subcategoryId,
          pageNum: pageNum,
          pageSize: this.pageSize,
          sort: "new"
        };
        // 使用新的分类页面接口
        this.axios
          .getXinWenKeCategory(params)
          .then(res => {
            if (res.data.code === 200) {
              const data = res.data.data || {};
              const files = data.files || [];
              const total = data.total || 0;
              
              // 根据模块更新对应的数据和选中状态
              if (module === 'zhengshizhe') {
                this.zhengshizheFiles = files;
                this.zhengshizheTotal = total;
                this.zhengshizhePageNum = pageNum;
                this.zhengshizheSelectedCategory = categoryId;
                this.zhengshizheSelectedSubcategory = subcategoryId;
              } else if (module === 'jingguanfa') {
                this.jingguanfaFiles = files;
                this.jingguanfaTotal = total;
                this.jingguanfaPageNum = pageNum;
                this.jingguanfaSelectedCategory = categoryId;
                this.jingguanfaSelectedSubcategory = subcategoryId;
              } else if (module === 'jiaoyu') {
                this.jiaoyuFiles = files;
                this.jiaoyuTotal = total;
                this.jiaoyuPageNum = pageNum;
                this.jiaoyuSelectedCategory = categoryId;
                this.jiaoyuSelectedSubcategory = subcategoryId;
              } else if (module === 'yishu') {
                this.yishuFiles = files;
                this.yishuTotal = total;
                this.yishuPageNum = pageNum;
                this.yishuSelectedCategory = categoryId;
                this.yishuSelectedSubcategory = subcategoryId;
              }
            }
          })
          .catch(err => {
            // 静默处理错误，避免控制台输出
          });
      },
  
      // 为指定模块加载文件数据（使用第一个子分类）
      loadModuleFilesWithSubcategory(module, categoryId) {
        // 获取第一个子分类ID
        let subcategoryId = null;
        if (this.subcategories.length > 0) {
          subcategoryId = this.subcategories[0].id;
        }
        
        const params = {
          categoryId: categoryId,
          subcategoryId: subcategoryId,
          pageNum: 1,
          pageSize: this.pageSize,
          sort: "new"
        };
  
        this.axios
          .getXinWenKeFiles(params)
          .then(res => {
            if (res.data.code === 200) {
              // 根据后端接口文档，分类页面返回的数据结构
              const files = res.data.data.files || [];
              const total = res.data.data.total || 0;
              
              // 根据模块更新对应的数据和选中状态
              if (module === 'zhengshizhe') {
                this.zhengshizheFiles = files;
                this.zhengshizheTotal = total;
                this.zhengshizhePageNum = 1;
                this.zhengshizheSelectedCategory = categoryId;
                this.zhengshizheSelectedSubcategory = subcategoryId;
              } else if (module === 'jingguanfa') {
                this.jingguanfaFiles = files;
                this.jingguanfaTotal = total;
                this.jingguanfaPageNum = 1;
                this.jingguanfaSelectedCategory = categoryId;
                this.jingguanfaSelectedSubcategory = subcategoryId;
              } else if (module === 'jiaoyu') {
                this.jiaoyuFiles = files;
                this.jiaoyuTotal = total;
                this.jiaoyuPageNum = 1;
                this.jiaoyuSelectedCategory = categoryId;
                this.jiaoyuSelectedSubcategory = subcategoryId;
              } else if (module === 'yishu') {
                this.yishuFiles = files;
                this.yishuTotal = total;
                this.yishuPageNum = 1;
                this.yishuSelectedCategory = categoryId;
                this.yishuSelectedSubcategory = subcategoryId;
              }
            }
          })
          .catch(err => {
            // 静默处理错误，避免控制台输出
          });
      },
  
      // 为指定模块按需加载文件数据（使用第一个子分类）
      loadModuleFiles(module, categoryId) {
        // 获取子分类ID，默认选择第一个子分类
        let subcategoryId = null;
        if (this.subcategories.length > 0) {
          subcategoryId = this.subcategories[0].id;
        }
        
        const params = {
          categoryId: categoryId,
          subcategoryId: subcategoryId,
          pageNum: 1,
          pageSize: this.pageSize,
          sort: "new"
        };
  
        this.axios
          .getXinWenKeFiles(params)
          .then(res => {
            if (res.data.code === 200) {
              // 根据后端接口文档，分类页面返回的数据结构
              const files = res.data.data.files || [];
              const total = res.data.data.total || 0;
              
              // 根据模块更新对应的数据
              if (module === 'zhengshizhe') {
                this.zhengshizheFiles = files;
                this.zhengshizheTotal = total;
                this.zhengshizhePageNum = 1;
              } else if (module === 'jingguanfa') {
                this.jingguanfaFiles = files;
                this.jingguanfaTotal = total;
                this.jingguanfaPageNum = 1;
              } else if (module === 'jiaoyu') {
                this.jiaoyuFiles = files;
                this.jiaoyuTotal = total;
                this.jiaoyuPageNum = 1;
              } else if (module === 'yishu') {
                this.yishuFiles = files;
                this.yishuTotal = total;
                this.yishuPageNum = 1;
              }
            }
          })
          .catch(err => {
            // 静默处理错误，避免控制台输出
          });
      },
  
      // 选择模块和分类（按需查询）
      selectModuleCategory(module, categoryId) {
        this.selectedModule = module;
        this.selectedCategory = categoryId;
        this.currentFiles = [];
        this.pageNum = 1; // 重置页码
        
        // 获取当前大分类下的子分类
        const moduleSubcategories = this.subcategories.filter(sub => sub.categoryId === categoryId);
        
        // 默认选中第一个子分类
        let selectedSubcategoryId = null;
        if (moduleSubcategories.length > 0) {
          selectedSubcategoryId = moduleSubcategories[0].id;
        }
        
        // 更新对应模块的选中状态
        if (module === 'zhengshizhe') {
          this.zhengshizheSelectedCategory = categoryId;
          this.zhengshizheSelectedSubcategory = selectedSubcategoryId;
        } else if (module === 'jingguanfa') {
          this.jingguanfaSelectedCategory = categoryId;
          this.jingguanfaSelectedSubcategory = selectedSubcategoryId;
        } else if (module === 'jiaoyu') {
          this.jiaoyuSelectedCategory = categoryId;
          this.jiaoyuSelectedSubcategory = selectedSubcategoryId;
        } else if (module === 'yishu') {
          this.yishuSelectedCategory = categoryId;
          this.yishuSelectedSubcategory = selectedSubcategoryId;
        }
        
        // 按需查询加载指定模块的数据
        if (selectedSubcategoryId) {
          this.loadModuleFilesWithSpecificSubcategory(module, categoryId, selectedSubcategoryId);
        }
      },
  
      // 选择分类（保留兼容性）
      selectCategory(categoryId) {
        this.selectedCategory = categoryId;
        this.selectedSubcategory = null;
        this.currentFiles = [];
        this.pageNum = 1; // 重置页码
        this.loadFiles();
      },
  
      // 选择子分类
      selectSubcategory(subcategoryId) {
        this.selectedSubcategory = subcategoryId;
        this.pageNum = 1; // 重置页码
        this.loadFiles();
      },
  
      // 选择模块子分类（按需查询）
      selectModuleSubcategory(module, subcategoryId) {
        this.selectedModule = module;
        this.selectedSubcategory = subcategoryId;
        this.pageNum = 1; // 重置页码
        
        // 更新对应模块的选中状态
        let categoryId = null;
        if (module === 'zhengshizhe') {
          this.zhengshizheSelectedSubcategory = subcategoryId;
          categoryId = this.zhengshizheSelectedCategory;
          this.selectedCategory = categoryId;
        } else if (module === 'jingguanfa') {
          this.jingguanfaSelectedSubcategory = subcategoryId;
          categoryId = this.jingguanfaSelectedCategory;
          this.selectedCategory = categoryId;
        } else if (module === 'jiaoyu') {
          this.jiaoyuSelectedSubcategory = subcategoryId;
          categoryId = this.jiaoyuSelectedCategory;
          this.selectedCategory = categoryId;
        } else if (module === 'yishu') {
          this.yishuSelectedSubcategory = subcategoryId;
          categoryId = this.yishuSelectedCategory;
          this.selectedCategory = categoryId;
        }
        
        // 按需查询加载指定模块的数据
        if (categoryId) {
          this.loadModuleFilesWithSpecificSubcategory(module, categoryId, subcategoryId);
        }
      },
  
      // 获取子分类列表（通用子分类）
      getSubcategories() {
        return this.subcategories;
      },
  
      // 获取政史哲模块的子分类
      getZhengshizheSubcategories() {
        if (!this.zhengshizheSelectedCategory) return [];
        return this.subcategories.filter(sub => sub.categoryId === this.zhengshizheSelectedCategory);
      },
  
      // 获取经管法模块的子分类
      getJingguanfaSubcategories() {
        if (!this.jingguanfaSelectedCategory) return [];
        return this.subcategories.filter(sub => sub.categoryId === this.jingguanfaSelectedCategory);
      },
  
      // 获取教育模块的子分类
      getJiaoyuSubcategories() {
        if (!this.jiaoyuSelectedCategory) return [];
        return this.subcategories.filter(sub => sub.categoryId === this.jiaoyuSelectedCategory);
      },
  
      // 获取艺术模块的子分类
      getYishuSubcategories() {
        if (!this.yishuSelectedCategory) return [];
        return this.subcategories.filter(sub => sub.categoryId === this.yishuSelectedCategory);
      },
  
      // 根据子分类ID获取子分类名称
      getSubcategoryName(subcategoryId) {
        const subcategory = this.subcategories.find(item => item.id === subcategoryId);
        return subcategory ? subcategory.name : '';
      },
  
      // 加载文件列表（按需查询）
      loadFiles() {
        if (!this.selectedCategory) return;
  
        this.loading = true;
        const params = {
          categoryId: this.selectedCategory,
          subcategoryId: this.selectedSubcategory,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          sort: "new"
        };
  
        this.axios
          .getXinWenKeFiles(params)
          .then(res => {
            if (res.data.code === 200) {
              // 根据后端接口文档，分类页面返回的数据结构
              const files = res.data.data.files || [];
              const total = res.data.data.total || 0;
              
              // 根据当前选中的模块更新对应的数据
              if (this.selectedModule === 'zhengshizhe') {
                this.zhengshizheFiles = files;
                this.zhengshizheTotal = total;
                this.zhengshizhePageNum = this.pageNum;
              } else if (this.selectedModule === 'jingguanfa') {
                this.jingguanfaFiles = files;
                this.jingguanfaTotal = total;
                this.jingguanfaPageNum = this.pageNum;
              } else if (this.selectedModule === 'jiaoyu') {
                this.jiaoyuFiles = files;
                this.jiaoyuTotal = total;
                this.jiaoyuPageNum = this.pageNum;
              } else if (this.selectedModule === 'yishu') {
                this.yishuFiles = files;
                this.yishuTotal = total;
                this.yishuPageNum = this.pageNum;
              }
              
              this.currentFiles = files;
              this.total = total;
            } else {
              this.currentFiles = [];
              this.total = 0;
            }
          })
          .catch(err => {
            this.$message.error("文件数据加载失败");
            this.currentFiles = [];
            this.total = 0;
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      // 查看文件详情
      viewFile(file) {
        const link = this.$router.resolve({
          name: "XinWenKeDetail",
          query: { code: file.code }
        });
        window.open(link.href, "_blank");
      },
  
      // 轮播图相关方法
      onImageLoad() {
        // 图片加载完成
      },
  
      addUrl(item) {
        // 处理轮播图点击事件
      },
  
      // 分页处理 - 政史哲模块（按需查询）
      handleZhengshizhePageChange(page) {
        this.loadModuleFilesWithSpecificSubcategory(
          'zhengshizhe', 
          this.zhengshizheSelectedCategory, 
          this.zhengshizheSelectedSubcategory, 
          page
        );
      },
  
      // 分页处理 - 经管法模块（按需查询）
      handleJingguanfaPageChange(page) {
        this.loadModuleFilesWithSpecificSubcategory(
          'jingguanfa', 
          this.jingguanfaSelectedCategory, 
          this.jingguanfaSelectedSubcategory, 
          page
        );
      },
  
      // 分页处理 - 教育模块（按需查询）
      handleJiaoyuPageChange(page) {
        this.loadModuleFilesWithSpecificSubcategory(
          'jiaoyu', 
          this.jiaoyuSelectedCategory, 
          this.jiaoyuSelectedSubcategory, 
          page
        );
      },
  
      // 分页处理 - 艺术模块（按需查询）
      handleYishuPageChange(page) {
        this.loadModuleFilesWithSpecificSubcategory(
          'yishu', 
          this.yishuSelectedCategory, 
          this.yishuSelectedSubcategory, 
          page
        );
      },
  
      // 通用分页处理（保留兼容性）
      handlePageChange(page) {
        this.pageNum = page;
        this.loadFiles();
      },
  
      ...mapMutations(["UP_BOOLE"])
    },
  
    watch: {
      screenWidth(val) {
        // 屏幕宽度变化处理
      }
    },
  
    mounted() {
      this.UP_BOOLE();
      this.getSwiperData();
      this.getReviewData();
      
      // 使用 Promise.all 确保分类和子分类数据都加载完成后再设置选中状态
      this.loadInitialData();
  
      const that = this;
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth;
        })();
      };
    }
  };
  </script>
  
  <style scoped>
  .xinwenke-page {
    min-height: 100vh;
    background-color: #f8f9fa;
  }
  
  /* 轮播图样式 */
  .swiper {
    position: relative;
    margin-bottom: 30px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  
  .swiper img {
    width: 100%;
    height: 625px;
    object-fit: cover;
  }
  
  .swiperBox .el-carousel__indicators {
    opacity: 0;
  }
  
  .swiperBox .el-carousel {
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
  }
  
  .swiperBox .el-carousel__container {
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
  }
  
  .swiperBox .el-carousel__item {
    border-radius: 8px;
    overflow: hidden;
  }
  
  /* 新文科模块标题区域样式 */
  .xinwenke-title-section {
    max-width: 1400px;
    margin: 50px auto 30px;
    padding: 0 20px;
  }
  
  .xinwenke-title-header {
    text-align: center;
    padding: 40px 30px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }
  
  .xinwenke-title-header h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin: 0 0 12px 0;
    letter-spacing: 2px;
  }
  
  .xinwenke-title-header p {
    font-size: 18px;
    color: #13a4e6;
    margin: 0;
    font-weight: 500;
    letter-spacing: 3px;
  }
  
  /* 新文科模块样式 */
  .xinwenke-modules {
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .module-section {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-bottom: 30px;
    padding: 0;
    overflow: hidden;
  }
  
  .module-header {
    text-align: center;
    margin-bottom: 0;
    padding: 25px 30px 20px 30px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #e0e0e0;
  }
  
  .module-header h2 {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0 0 6px 0;
  }
  
  .module-header p {
    font-size: 12px;
    color: #666;
    margin: 0;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  
  /* 分类标签样式 - 标签页风格 */
  .category-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    margin-bottom: 0;
    border-bottom: 2px solid #f0f0f0;
    background: #fafafa;
    border-radius: 8px 8px 0 0;
    padding: 0 10px;
    justify-content: center;
  }
  
  .category-tab {
    padding: 12px 24px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    position: relative;
    margin-right: 20px;
  }
  
  .category-tab:hover {
    background: #f0f8ff;
    color: #13a4e6;
  }
  
  .category-tab.active {
    background: #fff;
    color: #13a4e6;
    border-bottom-color: #13a4e6;
    box-shadow: 0 -2px 8px rgba(19, 164, 230, 0.1);
  }
  
  /* 子分类标签样式 - 与大标题风格统一 */
  .subcategory-tabs {
    display: flex;
    gap: 0;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .subcategory-tab {
    padding: 10px 24px;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    margin-right: 20px;
    white-space: nowrap;
    position: relative;
  }
  
  .subcategory-tab:hover {
    color: #13a4e6;
    background: #f8f9fa;
    border-radius: 4px;
  }
  
  .subcategory-tab.active {
    color: #13a4e6;
    border-bottom-color: #13a4e6;
  }
  
  /* 文件网格样式 */
  .files-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    margin: 20px 30px 30px 30px;
    padding: 0;
  }
  
  .file-card {
    background: #fff;
    border: 2px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: border-color 0.18s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  
  .file-card:hover {
    border-color: #31ADF7 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  
  .file-image {
    width: 100%;
    height: 200px;
    overflow: hidden;
  }
  
  .file-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .file-card:hover .file-image img {
    transform: none;
  }
  
  .file-info {
    padding: 10px 16px 5px;
  }
  
  .file-header {
    margin-bottom: 8px;
  }
  
  .file-type {
    font-size: 12px;
    color: #13a4e6;
    background: #f0f8ff;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
  }
  
  .file-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .file-left {
    flex: 1;
    min-width: 0;
  }
  
  .file-right {
    flex-shrink: 0;
  }
  
  .file-info h3 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .file-stats {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  
  .stat-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #666;
    white-space: nowrap;
  }
  
  .stat-item i {
    font-size: 14px;
    color: #13a4e6;
  }
  
  /* 分页样式 */
  .pagination-container {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
  
  /* 上一页下一页按钮样式 */
  .pagination-container .el-pagination .btn-prev,
  .pagination-container .el-pagination .btn-next {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    background: #fff;
    border: 2px solid #13a4e6;
    border-radius: 4px;
    padding: 8px 16px;
    transition: all 0.3s ease;
  }
  
  .pagination-container .el-pagination .btn-prev:hover,
  .pagination-container .el-pagination .btn-next:hover {
    color: #fff;
    background: #13a4e6;
  }
  
  .pagination-container .el-pagination .btn-prev:disabled,
  .pagination-container .el-pagination .btn-next:disabled {
    color: #999;
    background: #f5f5f5;
    border: 2px solid #ddd;
    cursor: not-allowed;
  }
  
  /* 响应式设计 */
  @media (max-width: 1200px) {
    .files-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  @media (max-width: 768px) {
    .xinwenke-title-section {
      margin: 30px auto 20px;
      padding: 0 10px;
    }
  
    .xinwenke-title-header {
      padding: 30px 20px;
    }
  
    .xinwenke-title-header h2 {
      font-size: 24px;
      letter-spacing: 1px;
    }
  
    .xinwenke-title-header p {
      font-size: 16px;
      letter-spacing: 2px;
    }
  
    .xinwenke-modules {
      padding: 10px;
    }
  
    .module-section {
      margin-bottom: 20px;
    }
  
    .module-header {
      padding: 20px 15px 15px 15px;
    }
  
    .module-header h2 {
      font-size: 20px;
    }
  
    .category-tabs {
      padding: 0 5px;
    }
  
    .category-tab {
      padding: 10px 16px;
      font-size: 13px;
      margin-right: 10px;
    }
  
    .subcategory-tabs {
      padding: 15px 20px;
    }
  
    .subcategory-tab {
      padding: 8px 20px;
      font-size: 13px;
      margin-right: 15px;
    }
  
    .files-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin: 15px 15px 20px 15px;
    }
  
    .file-image {
      height: 120px;
    }
  
    .swiper img {
      height: 300px;
    }
  
    .pagination-container {
      margin: 15px 0;
    }
  }
  
  @media (max-width: 480px) {
    .xinwenke-title-section {
      margin: 25px auto 15px;
      padding: 0 10px;
    }
  
    .xinwenke-title-header {
      padding: 25px 15px;
    }
  
    .xinwenke-title-header h2 {
      font-size: 20px;
      letter-spacing: 0.5px;
    }
  
    .xinwenke-title-header p {
      font-size: 14px;
      letter-spacing: 1px;
    }
  
    .files-grid {
      grid-template-columns: 1fr;
      margin: 15px 10px 20px 10px;
    }
  
    .category-tab {
      padding: 8px 12px;
      font-size: 12px;
      margin-right: 5px;
    }
  
    .subcategory-tab {
      padding: 6px 16px;
      font-size: 12px;
      margin-right: 8px;
    }
  
    .pagination-container {
      margin: 15px 0;
    }
  }
  
  /* 用户评价轮播区域样式 */
  .reviews-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    padding: 60px 0;
    margin-top: 40px;
  }
  
  .reviews-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .reviews-header {
    text-align: center;
    margin-bottom: 40px;
  }
  
  .reviews-header h2 {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin: 0 0 8px 0;
  }
  
  .reviews-header p {
    font-size: 14px;
    color: #666;
    margin: 0;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
  
  .reviews-content {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  
  .review-scroll {
    height: 120px;
    overflow: hidden;
    position: relative;
  }
  
  .review-scroll ul {
    display: flex;
    align-items: center;
    height: 100%;
  }
  
  .review-item {
    display: flex;
    align-items: center;
    padding: 18px 28px;
    background: #fff;
    border-radius: 8px;
    margin-right: 25px;
    box-shadow: 0 5px 18px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    white-space: nowrap;
    min-width: 420px;
    border-left: 5px solid #13a4e6;
    flex-shrink: 0;
  }
  
  .review-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
  
  .review-avatar {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 18px;
    flex-shrink: 0;
    border: 3px solid #f0f8ff;
  }
  
  .review-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .review-content {
    flex: 1;
  }
  
  .review-text {
    font-size: 16px;
    color: #333;
    line-height: 1.5;
    margin-bottom: 6px;
    font-weight: 500;
  }
  
  .review-user {
    font-size: 14px;
    color: #13a4e6;
    font-weight: 600;
  }
  
  /* 服务保障区域样式 */
  .itmentBox {
    width: 100%;
    background: #fff;
  }
  
  .tment_ul {
    max-width: 1400px;
    margin: 0 auto;
  }
  
  .tment_ul li {
    width: 33.3333333%;
    height: 300px;
    float: left;
    padding-top: 60px;
    box-sizing: border-box;
    text-align: center;
    position: relative;
  }
  
  .tment_ul li i {
    font-size: 78px;
    line-height: 78px;
    height: 78px;
    margin-bottom: 20px;
    color: #2FA4F5;
    display: block;
  }
  
  .decla_title {
    font-size: 20px;
    color: #333333;
    height: 28px;
    line-height: 28px;
    margin-bottom: 5px;
  }
  
  .decla_intro {
    font-size: 14px;
    color: #999999;
    line-height: 22px;
  }
  
  .tment_ul li::after {
    content: '';
    width: 14px;
    height: 14px;
    display: block;
    background: #E9EAEF;
    position: absolute;
    right: -7px;
    top: 50%;
    border-radius: 50%;
  }
  
  .tment_ul li.last_item::after {
    display: none;
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .reviews-section {
      padding: 40px 0;
      margin-top: 30px;
    }
  
    .reviews-header h2 {
      font-size: 24px;
    }
  
    .review-item {
      min-width: 320px;
      padding: 15px 22px;
    }
  
    .review-avatar {
      width: 45px;
      height: 45px;
      margin-right: 15px;
    }
  
    .review-text {
      font-size: 15px;
    }
  
    .review-user {
      font-size: 13px;
    }
  
    .tment_ul li {
      width: 100%;
      height: auto;
      padding: 40px 20px;
      margin-bottom: 20px;
    }
  
    .tment_ul li i {
      font-size: 60px;
      line-height: 60px;
      height: 60px;
      margin-bottom: 15px;
    }
  
    .decla_title {
      font-size: 18px;
      margin-bottom: 8px;
    }
  
    .decla_intro {
      font-size: 13px;
    }
  
    .tment_ul li::after {
      display: none;
    }
  }
  </style>
  